import { useState } from "react";
import { US_STATES } from "@/data/siteContent";
import { useLeadSubmit, ConsentCheckbox, Honeypot, FieldError } from "@/components/forms/shared";

const CONTACT_METHODS = ["Phone call", "Text message", "Email"];

export default function ContactForm() {
  const { submit, submitting } = useLeadSubmit("contact");
  const [form, setForm] = useState({ name: "", phone: "", email: "", state: "", message: "", preferred_contact: "" });
  const [consent, setConsent] = useState(false);
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});

  const set = (k) => (e) => { setForm({ ...form, [k]: e.target.value }); setErrors((p) => ({ ...p, [k]: "" })); };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please enter your name.";
    if (!form.phone.trim()) e.phone = "Please enter your phone number.";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) e.email = "Please enter a valid email address.";
    if (!form.state) e.state = "Please select your state.";
    if (!form.message.trim()) e.message = "Please tell us how we can help.";
    if (!consent) e.consent = "Please confirm your consent so we may contact you.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  return (
    <form className="relative rounded-2xl border border-navy-100 bg-white p-6 sm:p-8 shadow-lg"
      onSubmit={(e) => { e.preventDefault(); if (validate()) submit(form, { consent, company }); }}
      noValidate data-testid="contact-form">
      <Honeypot value={company} onChange={setCompany} />
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="field-label" htmlFor="cf-name">Name</label>
          <input id="cf-name" className="field-input" autoComplete="name" value={form.name} onChange={set("name")} data-testid="contact-name" />
          <FieldError message={errors.name} />
        </div>
        <div>
          <label className="field-label" htmlFor="cf-phone">Phone</label>
          <input id="cf-phone" type="tel" className="field-input" autoComplete="tel" value={form.phone} onChange={set("phone")} data-testid="contact-phone" />
          <FieldError message={errors.phone} />
        </div>
        <div>
          <label className="field-label" htmlFor="cf-email">Email</label>
          <input id="cf-email" type="email" className="field-input" autoComplete="email" value={form.email} onChange={set("email")} data-testid="contact-email" />
          <FieldError message={errors.email} />
        </div>
        <div>
          <label className="field-label" htmlFor="cf-state">State</label>
          <select id="cf-state" className="field-input" value={form.state} onChange={set("state")} data-testid="contact-state">
            <option value="">Select state</option>
            {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <FieldError message={errors.state} />
        </div>
        <div className="sm:col-span-2">
          <label className="field-label" htmlFor="cf-method">Preferred contact method</label>
          <select id="cf-method" className="field-input" value={form.preferred_contact} onChange={set("preferred_contact")} data-testid="contact-method">
            <option value="">Select one (optional)</option>
            {CONTACT_METHODS.map((m) => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div className="sm:col-span-2">
          <label className="field-label" htmlFor="cf-message">How can we help?</label>
          <textarea id="cf-message" className="field-input min-h-[120px]" value={form.message} onChange={set("message")} data-testid="contact-message" />
          <FieldError message={errors.message} />
        </div>
      </div>
      <div className="mt-5">
        <ConsentCheckbox checked={consent} onChange={(v) => { setConsent(v); setErrors((p) => ({ ...p, consent: "" })); }} error={errors.consent} testid="contact" />
      </div>
      <button type="submit" className="btn-accent mt-6 w-full sm:w-auto" disabled={submitting} data-testid="contact-submit-button">
        {submitting ? "Sending…" : "Send My Message"}
      </button>
    </form>
  );
}
